import request from '@/router/axios';
//const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '' : '/sys'
//const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : ''
const urlPrefix = '/wage'
//查询
export function  getTaxList(obj) {
  return request({
    url: urlPrefix + '/tax/getTaxList',
    method: 'POST',
    data: obj
  })
}

/**
 *  根据Id查询申报批次
 */
export function getTaxBatchById(id) {
  return request({
    url: urlPrefix +'/tax/getTaxBatchById',
    method: 'POST',
    data: id
  });
}

//修改申报状态
export function  updateTaxBatch(obj) {
  return request({
    url: urlPrefix + '/tax/update/updateTaxBatch',
    method: 'put',
    data:obj
  })
}
//查询报税主体遗漏人员
export function  queryLeavePerson(obj) {
  return request({
    url: urlPrefix + '/tax/queryLeavePerson',
    method: 'POST',
    data:obj
  })
}
//根据批次id,税金明细id查询人员信息
export function getBatchEmpByIdList(obj){
 return request({
   url: urlPrefix + '/tax/getBatchEmpByIdList',
    method:'POST',
   data: obj,
  })
}

//根据批次id,税金明细id,计税类型，是否居民纳税人，查询正常工资所得
export function getTaxNormalWagesList(obj){
  return request({
    url: urlPrefix + '/tax/getTaxNormalWagesList',
    method:'POST',
    data: obj,
  })
}

//根据批次id,税金明细id,计税类型，是否居民纳税人，查询非居民正常工资薪金所得
export function getTaxResidentWagesList(obj){
  return request({
    url: urlPrefix + '/tax/getTaxResidentWagesList',
    method:'POST',
    data: obj,
  })
}
//根据批次id,税金明细id,计税类型，是否居民纳税人，查询劳务报酬所得
export function getTaxIncomeWagesList(obj){
  return request({
    url: urlPrefix + '/tax/getTaxIncomeWagesList',
    method:'POST',
    data: obj,
  })
}
//根据批次id,税金明细id,计税类型，是否居民纳税人，查询个人股权激励收入
export function getTaxPersonEquityList(obj){
  return request({
    url: urlPrefix + '/tax/getTaxPersonEquityList',
    method:'POST',
    data: obj,
  })
}
//根据批次id,税金明细id,计税类型，是否居民纳税人，解除劳动合同一次性补偿金
export function getTaxQuitWagesList(obj){
  return request({
    url: urlPrefix + '/tax/getTaxQuitWagesList',
    method:'POST',
    data: obj,
  })
}
//根据批次id,税金明细id,计税类型，是否居民纳税人，查询全年一次性奖金
export function getTaxAnnualWagesList(obj){
  return request({
    url: urlPrefix + '/tax/getTaxAnnualWagesList',
    method:'POST',
    data: obj,
  })
}



//查询员工工资及离职金
export function getEmpWagesList(obj){
  return request({
    url: urlPrefix + '/tax/getEmpWagesList',
    method:'POST',
    data: obj,
  })
}
//查询员工工资明细
export function getEmpWagesDetailList(obj){
  return request({
    url: urlPrefix + '/tax/getEmpWagesDetailList',
    method:'POST',
    data: obj,
  })
}
//查询成本中心汇总报表
export function getCostCenterSummaryList(obj){
  return request({
    url: urlPrefix + '/tax/getCostCenterSummaryList',
    method:'POST',
    data: obj,
  })
}
//查询工资对比报表
export function getWageComparisonList(obj){
  return request({
    url: urlPrefix + '/tax/getWageComparisonList',
    method:'POST',
    data: obj,
  })
}
//查询平均工资报表
export function getAverageWageList(obj){
  return request({
    url: urlPrefix + '/tax/getAverageWageList',
    method:'POST',
    data: obj,
  })
}
//查询成本核算报表
export function getCostAccountingList(obj){
  return request({
    url: urlPrefix + '/tax/getCostAccountingList',
    method:'POST',
    data: obj,
  })
}
//查询成本核算报表-按项目生成
export function getCostAccountingProjectList(obj){
  return request({
    url: urlPrefix + '/tax/getCostAccountingProjectList',
    method:'POST',
    data: obj,
  })
}
//查询税率汇总报表
export function getTaxRateSummaryList(obj){
  return request({
    url: urlPrefix + '/tax/getTaxRateSummaryList',
    method:'POST',
    data: obj,
  })
}
//查询税率汇总报表
export function getTaxCompanyList(obj){
  return request({
    url: urlPrefix + '/tax/getTaxCompanyList',
    method:'POST',
    data: obj,
  })
}
//校验表头
export function checkTitle(obj) {
  return request({
    url: urlPrefix + '/tax/checkTitle',
    method:'POST',
    data: obj,
  })
}
//查询稿酬报表
export function getTaxRemunerationList(obj) {
  return request({
    url: urlPrefix + '/tax/getTaxRemunerationList',
    method:'POST',
    data: obj,
  })
}
//查询特许权使用费
export function getTaxLoyalitiesList(obj) {
  return request({
    url: urlPrefix + '/tax/getTaxLoyalitiesList',
    method:'POST',
    data: obj,
  })
}
//查询利息股息红利所得
export function getTaxInterestList(obj) {
  return request({
    url: urlPrefix + '/tax/getTaxInterestList',
    method:'POST',
    data: obj,
  })
}
//查询利息股息红利所得
export function getTaxAccidentalList(obj) {
  return request({
    url: urlPrefix + '/tax/getTaxAccidentalList',
    method:'POST',
    data: obj,
  })
}
//查询财产转移
export function getTaxTransPropertyList(obj) {
  return request({
    url: urlPrefix + '/tax/getTaxTransPropertyList',
    method:'POST',
    data: obj,
  })
}
//查询财产租赁
export function getTaxLeasePropertyList(obj) {
  return request({
    url: urlPrefix + '/tax/getTaxLeasePropertyList',
    method:'POST',
    data: obj,
  })
}

//查询其他连续劳务所得
export function getOtherIncomeWagesList(obj) {
  return request({
    url: urlPrefix + '/tax/getOtherIncomeWagesList',
    method:'POST',
    data: obj,
  })
}

